<template>
  <div
    class="column_start_end store_banner"
    :class="{ store_banner_pending: isStoreImagePending }"
    :style="bannerStyle"
  >
    <div class="row_center_between gradient_view">
      <text>{{ store }}</text>
      <div
        class="row_center_around vip_text"
        v-if="isLogin && showVipCard"
        @click="toMemberPage"
      >
        <img src="@/assets/triangle.png" />
        <text>VIP會員卡</text>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    store: {
      type: String,
      default: "",
      required: true,
    },
    showVipCard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    getCurrentStore() {
      return this.$store.state.basic.currentStore;
    },
    isLogin() {
      return this.$store.getters["userData/isLogin"];
    },
    // 店家圖片快取需屬於網址上的店家，避免切換店家時顯示上一家店的圖片
    storeImageUrl() {
      const imageUrl = this.$store.getters["basic/storeInfoImageUrl"];
      const imageStoreCode = this.$store.state.basic.storeImagesStoreCode;
      if (!imageUrl || imageStoreCode !== this.$route.params.store) return null;
      return imageUrl;
    },
    // 尚未確認這家店有無圖片時顯示灰底，避免先閃預設圖再換成店家圖片
    isStoreImagePending() {
      if (this.storeImageUrl) return false;
      const checkedStoreCode =
        this.$store.state.basic.storeImagesCheckedStoreCode;
      if (checkedStoreCode === this.$route.params.store) return false;
      // 未登入且沒有 LINE token 時不會載入圖片，直接顯示預設圖
      const lineAccessToken = this.$store.getters["line/accessToken"];
      return this.isLogin || !!lineAccessToken;
    },
    // 沒有店家圖片時不設定 inline style，沿用 CSS 預設背景圖
    bannerStyle() {
      if (!this.storeImageUrl) return null;
      return { backgroundImage: `url("${this.storeImageUrl}")` };
    },
  },
  methods: {
    toMemberPage() {
      this.$router.push(`/${this.getCurrentStore}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.store_banner {
  width: 100%;
  height: 214px;
  background-image: url("@/assets/store/store_banner_background.jpeg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  flex-shrink: 0;
}

.store_banner_pending {
  background-image: none;
  background-color: #e5e5e5;
}

.gradient_view {
  width: 100%;
  height: 50px;
  padding: 0 4%;
  font-size: 16px;
  font-weight: 400;
  font-family: PingFang SC;
  color: #fff;
  background: rgb(0, 0, 0);
  background: -moz-linear-gradient(
    270deg,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: -webkit-linear-gradient(
    270deg,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  background: linear-gradient(
    270deg,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000", endColorstr="#000000", GradientType=1);
}

.vip_text {
  padding: 8px 10px;
  width: 100px;
  height: 36px;
  border-radius: 6px;
  border: 1px solid #fbcb02;
  color: #fbcb02;
  line-height: 20px;
  font-size: 14px;

  img {
    width: 6px;
    height: 8px;
  }
}
</style>
